namespace $.$$ {
	export class $shm_hitalama_map_widget_float_code_bench_result extends $.$shm_hitalama_map_widget_float_code_bench_result {
		
		copy_text() {
			try {
				return this.result_text()
			} catch (error) {
				console.error(error)
				if( $mol_promise_like( error ) ) $mol_fail_hidden( error )
				return this.$.$mol_error_message( error )
			}
		}

		@ $mol_mem
		result_text() {
			const res = this.state()
			if( res?._format == 'error' ) return this.error_text()
			return typeof res === 'string' ? res : JSON.stringify( res, null, '\t' )
		}

		result_view() {
			const res = this.state()
			if( res?._format == 'error' ) return [ this.Error() ]
			if( res?._format == 'table' ) return [ this.Result_table() ]
			return [ this.Result() ]
		}

		error_text() {
			const res = this.state()
			return [
				`# Error: ${ res?.message ?? 'Error' }`,
				'```text',
				this.error_stack_text(),
				'```',
			].join( '\n' )
		}

		error_stack_text() {
			const stack = this.state()?.stack
			if( typeof stack !== 'string' ) return ''

			return stack.replace(
				/((?:[a-z]+:\/\/|[A-Za-z]:[\\/]|[\\/])?[^\s()]+[\\/][^\s():]+):(\d+):(\d+)/gi,
				( _, source: string, line: string, column: string )=> `${ this.error_stack_source_name( source ) }:${ line }:${ column }`,
			)
		}

		error_stack_source_name( source: string ) {
			return source.split( /[\\/]/ ).pop() || source
		}
		
		@ $mol_mem
		result_table_rows() {
			return this.state().table.rows
		}

		@ $mol_mem
		result_table_col_ids() {
			const head: string[] = this.state().table.head
			return head.map( (_,i) => i )
		}

		@ $mol_mem_key
		col_head_content( n: number ) {
			const head: string[] = this.state().table.head
			return [ head?.[n] || '' ]
		}

	}
}
